<!-- // Created by 任泽阳 on 18/12/06.
// 登录页面 -->
<template>
  <section class="page-login">
    <c-dialog
      :showFlag="dialogFlag"
      paddingBottom="14px"
      :confirmLoading="dialogConfirmLoading"
      :confirmDisabled="dialogConfirmDisabled"
      :haveOption="dialoghaveOption"
      @close="dialogClose"
      @confirm="dialogConfirm"
      :titleText="titleText"
    >
      <div class="singPass-dialog-content">
        <div class="singPass-login-content a-4-bg b-1-cl">
          <!-- <div class="account-login" @click="accountLogin">
              <svg class="icon icon-42" aria-hidden="true">
                <use xlink:href="#icon-g_4"></use>
              </svg>
            </div> -->
          <div id="qr_wrapper"></div>
          <div v-if="isShowRefresh" class="spcpqr-cent">
            <p class="b-1-cl">{{ $t("singPassLogin.mainText3") }}</p>
            <c-button @click="refreshHandler" height="30px" class="header-login-button">
              {{ $t("singPassLogin.mainText4") }}
            </c-button>
          </div>
          <div class="sys">
            <div class="sys-icon">
              <svg class="icon icon-32" aria-hidden="true">
                <use xlink:href="#icon-f_5"></use>
              </svg>
            </div>
            <div class="sys-text">
              <p>
                {{ $t("singPassLogin.mainText5") }}
                <span class="u-8-cl"> {{ $t("singPassLogin.mainText6") }}</span>
              </p>
              <p>{{ $t("singPassLogin.mainText7") }}</p>
            </div>
          </div>
        </div>
        <div class="dow-singpass-app">
          {{ $t("singPassLogin.mainText8") }}
          <span @click="goDow" class="u-8-cl">{{ $t("singPassLogin.mainText9") }}</span>
        </div>
      </div>
    </c-dialog>
    <c-dialog
      :showFlag="assDialogFlag"
      paddingBottom="14px"
      :confirmLoading="assDialogConfirmLoading"
      :confirmDisabled="assDialogConfirmDisabled"
      @close="dialogClosetwo"
      class="selselogintype-dialog"
      @confirm="assDialogConfirm"
      :titleText="titleText"
    >
      <div>
        <p class="b-7-cl">
          <svg style="float: left" aria-hidden="true" class="icon icon-16">
            <use xlink:href="#icon-c_2"></use>
          </svg>
          {{ $t("singPassLogin.mainText10") }}
        </p>
        <div class="singPass-login-content b-1-cl">
          <div class="ass-item a-4-bg u-8-bd" @click="singPassLogin(1)">
            {{ $t("singPassLogin.mainText11") }}
          </div>
          <div class="ass-item a-4-bg u-8-bd" @click="singPassLogin(2)">
            {{ $t("singPassLogin.mainText12") }}
          </div>
        </div>
      </div>
    </c-dialog>
  </section>
</template>
<script>
import { imgMap, setCookie, getScript } from '@/utils';

export default {
  name: 'singPassLogin',
  data() {
    return {
      ko64: imgMap.ko6_4,
      dialogFlag: false,
      dialogConfirmLoading: false,
      dialogConfirmDisabled: false,
      dialoghaveOption: false,
      assDialogFlag: false,
      assDialogConfirmLoading: false,
      assDialogConfirmDisabled: false,
      isShowRefresh: false,
      sTime: 0,
      setInterval: null,
      clientId: 'ECXX',
      clientCodeRequestUrl: null,
      redirectUri: null,
    };
  },
  props: {
    isShow: {
      default: true,
      type: Boolean,
    },
  },
  watch: {
    // isShow() {
    //   // this.dialogFlag = val;
    //   // if (val) {
    //   //   this.initSingPass();
    //   // }
    // },
    thirdPartyLoginData(data) {
      if (data !== null) {
        if (data.text === 'success') {
          this.dialogFlag = true;
          this.clientId = data.data.client_id;
          this.clientCodeRequestUrl = data.data.client_code_request_url;
          this.redirectUri = data.data.redirect_uri;
          this.initSingPass();
        }
      }
    },
  },
  computed: {
    titleText() {
      return this.$t('singPassLogin.mainText2'); // 'SingPass第三方登录';
    },
    singPassCode() {
      return this.$route.query.code;
    },
    singpassState() {
      return this.$route.query.state;
    },
    singpassSource() {
      return this.$route.query.source;
    },
    // 获取二维码的信息
    thirdPartyLoginData() {
      return this.$store.state.baseData.thirdPartyLoginData;
    },
    // 当前域名
    domainName() {
      return window.location.origin;
    },
  },
  mounted() {
    // 这应该是一个第三方登录的逻辑,不过资源地址已经失效,暂时不调用,用到肯定需要再次对接
    // this.init();
  },
  methods: {
    init() {
      getScript('../../static/js/jquery-3.3.1.min.js').then(() => {
        getScript(
          'https://saml.singpass.gov.sg/spcpextrest/resources/js/spcp-pvt-qr-v1.0.0.js',
        ).then(() => {});
      });
      if (this.singPassCode && this.singpassState && !this.singpassSource) {
        this.singPassRelation();
      }
    },
    // 查询 授权用户与平台用户是都关联
    singPassRelation() {
      this.axios({
        url: 'thirdPartLogin/singPassRelation',
        method: 'post',
        header: {},
        params: {
          singPassCode: this.singPassCode,
        },
      })
        .then((data) => {
          if (data.code.toString() === '0') {
            // 已存在关联 登录成功
            if (data.data.exitSingPass === 1) {
              setCookie('token', data.data.token); // 存储cookie
              // 登录成功
              this.$bus.$emit('tip', { text: this.$t('login.loginSuccess'), type: 'success' });
              // 获取 userinfo
              this.$store.dispatch('getUserInfo');
              this.getMySymbol();
              this.$router.push('/');
            } else {
              // 不存在关联
              this.singPassCode = data.data.singPassCode;
              this.assDialogFlag = true;
            }
          } else {
            this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          }
        })
        .catch(() => {});
    },
    refreshHandler() {
      window.SPCPQR.refresh();
      this.isShowRefresh = false;
      this.setsTime();
    },
    initSingPass() {
      this.sTime = 0;
      this.isShowRefresh = false;
      setTimeout(() => {
        window.SPCPQR.init(
          'qr_wrapper',
          {
            state: new Date().getTime(),
            nonce: new Date().getTime(),
            clientId: this.clientId,
            responseType: 'code',
            redirectUri: `${this.redirectUri}`,
            scope: 'openid',
          },
          this.refreshHandler,
        );
        this.setsTime();
      });
    },
    accountLogin() {
      const state = new Date().getTime();
      const nonce = new Date().getTime();
      const { clientId } = this;
      const responseType = 'code';
      // const redirectUri = `${this.domainName}/${this.redirectUri}`;
      // const redirectUri = 'http://rd3www.chaindown.com/zh_CN/login';
      const scope = 'openid';
      const url = `${this.clientCodeRequestUrl}?response_type=${responseType}&scope=${scope}&client_id=${clientId}&nonce=${nonce}&state=${state}&redirect_uri=${this.redirectUri}`;
      window.open(url);
    },
    goDow() {
      window.open('https://singpassmobile.sg/');
    },
    dialogClose() {
      this.dialogFlag = false;
    },
    dialogClosetwo() {
      this.assDialogFlag = false;
      this.$router.push('login');
    },
    dialogConfirm() {},
    assDialogConfirm() {},
    setsTime() {
      clearInterval(this.setInterval);
      this.sTime = 0;
      this.setInterval = setInterval(() => {
        this.sTime += 1;
        if (this.sTime >= 120) {
          this.isShowRefresh = true;
          clearInterval(this.setInterval);
        }
      }, 1000);
    },
    singPassLogin(val) {
      this.assDialogFlag = false;
      // 跳转注册
      if (val === 1) {
        this.$router.push(
          `register?singPassCode=${this.singPassCode}&singPassState=${this.singpassState}`,
        );
      } else {
        this.$bus.$emit('setLoginMode', 'SingPass');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.singPass-login-content {
  position: relative;
  padding: 30px 0;
  .account-login {
    position: absolute;
    cursor: pointer;
    right: 5px;
    top: 5px;
  }
  #qr_wrapper {
    width: 250px;
    height: 224px;
    margin: 0 auto;
    overflow: hidden;
    background: #fff;
    .spcpqr-c386.spcpqr-b3e6 .spcpqr-120f,
    .spcpqr-c386 .spcpqr-120f,
    .spcpqr-c386.spcpqr-b3e6 .spcpqr-9e90 {
      display: none;
    }
    .spcpqr-c386.spcpqr-b3e6 .spcpqr-be88 {
      opacity: 1;
    }
    .spcpqr-c386 {
      padding: 30px 0;
    }
    .spcpqr-c386 .spcpqr-be88 .spcpqr-a5c3 {
      width: 50px;
    }
  }
  .spcpqr-cent {
    background: rgba(29, 38, 53, 0.8);
    position: absolute;
    width: 250px;
    height: 224px;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 9;
    p {
      margin: 100px 0 20px;
    }
    .common-button-slot {
      font-size: 12px;
    }
  }
  .sys {
    width: 250px;
    margin: 24px auto 0;
    .sys-icon {
      float: left;
      width: 32px;
      height: 32px;
    }
    .sys-text {
      padding-left: 46px;
      width: 140px;
      line-height: 18px;
      font-size: 14px;
    }
  }
  .ass-item {
    height: 70px;
    line-height: 70px;
    padding-left: 30px;
    margin-top: 1px;
    cursor: pointer;
    border-radius: 3;
    &:hover {
      height: 68px;
      line-height: 68px;
      padding-left: 29px;
      border-width: 1px;
      border-style: solid;
    }
  }
}
.dow-singpass-app {
  text-align: right;
  margin: 20px 0;
  font-size: 12px;
  span {
    cursor: pointer;
  }
}
.selselogintype-dialog {
  color: #fff;
  .common-button {
    margin: 0;
  }
  .common-button-solid {
    display: none;
  }
}
</style>
